import React from 'react';
import { experienceData } from '../data/mockData';
import { Briefcase } from 'lucide-react';

const Experience = () => {
  return (
    <section className="py-24 px-6 fade-in-section">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="font-playfair text-5xl md:text-6xl font-bold mb-6">
            Professional <span className="text-gold">Experience</span>
          </h2>
        </div>
        
        <div className="space-y-12">
          {experienceData.map((exp, index) => (
            <div 
              key={index}
              className="relative pl-12 pb-12 border-l-2 border-gold/30 last:border-l-0 last:pb-0"
            >
              <div className="absolute left-0 top-0 -translate-x-[9px] w-4 h-4 rounded-full bg-gold"></div>
              
              <div className="bg-zinc-950 p-8 border border-gray-800 hover:border-gold/50 transition-all duration-300">
                <div className="flex items-start justify-between mb-6">
                  <div className="flex items-start gap-4">
                    <Briefcase className="text-magenta flex-shrink-0 mt-1" size={24} />
                    <div>
                      <h3 className="font-playfair text-2xl md:text-3xl font-bold mb-2">{exp.company}</h3>
                      <p className="text-gold text-lg mb-1">{exp.role}</p>
                    </div>
                  </div>
                  <span className="text-gray-400 text-sm whitespace-nowrap ml-4">{exp.period}</span>
                </div>
                
                <ul className="space-y-3">
                  {exp.responsibilities.map((item, idx) => (
                    <li key={idx} className="text-gray-300 leading-relaxed flex items-start">
                      <span className="text-gold mr-3 mt-1">•</span>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Experience;